import React, { useState, useEffect } from 'react';

const ScrollDetector = ({ scrollHeight, onScrollAbove, onScrollBelow }) => {
  const [hasScrolledAbove, setHasScrolledAbove] = useState(false);
  const [hasScrolledBelow, setHasScrolledBelow] = useState(false);

  const handleScroll = () => {
    const currentScrollHeight = window.scrollY;

    if (currentScrollHeight >= scrollHeight && !hasScrolledAbove) {
      setHasScrolledAbove(true);
      setHasScrolledBelow(false);
      // Execute the callback when the user scrolls above the specified height
      if (onScrollAbove) {
        onScrollAbove();
      }
    } else if (currentScrollHeight < scrollHeight && !hasScrolledBelow) {
      setHasScrolledAbove(false);
      setHasScrolledBelow(true);
      // Execute the callback when the user scrolls below the specified height
      if (onScrollBelow) {
        onScrollBelow();
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [hasScrolledAbove, hasScrolledBelow]);

  return <div>{/* Your component content goes here */}</div>;
};

export default ScrollDetector;
